var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    {
      staticClass: "effect-text text-center text-capitalize",
      attrs: { sm: "6", lg: "2" }
    },
    [
      _vm._v("\n  " + _vm._s(_vm.action) + "\n  "),
      _c("br"),
      _vm._v(" "),
      _c(
        "v-card",
        {
          staticClass: "pt-4 pb-4",
          attrs: { tile: "", color: "action--" + _vm.action }
        },
        [
          _c("v-icon", { attrs: { size: "100", dark: "" } }, [
            _vm._v(_vm._s(_vm.icon))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }